import { callApiToServer } from '../callApi';

export async function getCardReport(
  authtoken,
  startDate,
  endDate,
  filter,
  distributorId,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        startDate : startDate,
        endDate : endDate
    });
        //   add dis id remaining
    let endUrl = `v1/auth/list-buy-card-report?filterBy=${filter}${distributorId && "&distributorId="+distributorId}`
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
